import React from 'react';
import './w3.css';
import './fonts.css';
import './resume.css';

var Waypoint = require('react-waypoint');

var Scroll    = require('react-scroll');
var Link       = Scroll.Link;
var scroll     = Scroll.animateScroll;

class ProfileCard extends React.Component {
  constructor(props) {
    super(props);
    

    this.state = {
      showMemeTrainer: '',
    };

  }


  memeTrainerClickFunction(e) {
    if (this.props.isMobile){
      if (this.state.showMemeTrainer=== ' w3-show'){
        this.setState({showMemeTrainer: '',});
      }else{
        this.setState({showMemeTrainer: ' w3-show',});
      }
      e.preventDefault();
      //alert(e.target.tagName);
      ///   setTimeout to close window

    }
  }

 
  render() {

    this.memeTrainerClass = "socialLink w3-dropdown-" + (this.props.isMobile ? "click" : "hover") ;


    return (
        <div className={`w3-third profileCard`}>
        
          <div className={`w3-creme w3-text-grey w3-card-4`}>
            <div className={`w3-display-container `}>
              <Waypoint  onEnter={() => this.props.setPage('profileCard')}/>

              <img className={`Avatar`} src="cv/images/profile.png"  alt="Avatar" />
              <div className={`w3-display-topleft w3-container w3-text-black`}>
                <h2>Frazer<br/>Kirkman</h2>
              </div>
            </div>
            <Waypoint  onEnter={() => this.props.setPage('profileCard')}/>
            <div className={`w3-container w3-center`}>
              <div className={`intro-description`}>                
                <p><i className={`fa fa-briefcase fa-fw w3-margin-right w3-large w3-text-teal`}></i>Full Stack Engineer</p>
                <p><i className={`fa fa-envelope fa-fw w3-margin-right w3-large w3-text-teal`}></i><a href="mailto:frazer@frazerk.net?subject=Our company is interested in you&body=Dear Frazer,">frazer@frazerk.net</a></p>
                <p><i className={`fa fa-phone fa-fw w3-margin-right w3-large w3-text-teal`}></i>{this.props.isMobile?<a href="tel:+14158672294">+1 415 867 2294</a>:<a>+1 415 867 2294</a>}</p>
              </div>
              <Waypoint  onEnter={() => this.props.setPage('profileCard')}/>

              <div id="social">
                <a className={`socialLink`} href="https://github.com/Frazer" target="_blank" ><img className={`socialLink`} src="cv/images/github.png" alt="github link"/></a>&nbsp;
                <a  className={this.memeTrainerClass} href="http://meme-trainer.herokuapp.com" target="_blank" ><img  onClick={this.memeTrainerClickFunction.bind(this)} className={`socialLink`} src="cv/images/memeTrainer.png" alt="link to meme trainer"/>
                  <div  className={`memeTrainerIntro-content w3-dropdown-content w3-animate-zoom w3-panel w3-yellow w3-border w3-round-xlarge ${this.state.showMemeTrainer}`}>
                    <p>Click in here to see a little project I built with Meteor and React.
                    It is a <span className={`w3-text-blue`}>Meme Trainer</span> designed to help you create the habits and lifestyle you want.
                    Some components I created here can be found on my github page.
                    You have to log in to explore the features, which I encourage you to do.
                    {this.props.isMobile? <span><br/>It looks like you are viewing this on a mobile. To close this description, please click again on the brain icon </span> : '' }
                    </p>
                  </div>
                </a>&nbsp;
                <a className={`socialLink`} href="http://au.linkedin.com/in/frazerkirkman/" target="_blank" ><img className={`socialLink`} src="cv/images/LinkedIN.png" alt="linked in link"/></a>&nbsp;
                <a className={`socialLink`} href="http://www.youtube.com/user/unitedvisionaries/videos" target="_blank" ><img className={`socialLink`} src="cv/images/youtube.png" alt="youtube link"/></a>&nbsp;
                <a className={`socialLink`} href="https://twitter.com/frazerkirkman" target="_blank" ><img className={`socialLink`} src="cv/images/twitter.png" alt="twitter link"/></a>&nbsp;
                <a className={`socialLink`} href="https://www.facebook.com/frazerkirkman" target="_blank" ><img className={`socialLink`} src="cv/images/fb.png" alt="facebook link"/></a>&nbsp;
                <span className="stretch"></span>
              </div>
            </div>
          </div><br />

        { /* <!-- End Left Column --> */ }
        </div>
    );
  }
}
 
class DisplayModal extends React.Component {


  componentDidMount() {
    const el = this.modalElement;
     if(el && this.props.reference){
      if(this.props.isMobile){
        el.style.setProperty("top", "10px", "important");
      }else{
        let moveUp = el.clientHeight/2;
        let pos = 20;
        if(this.props.topPos-moveUp<20 ){
          el.style.setProperty("top", "20px", "important");
        }else if(this.props.topPos+moveUp>window.innerHeight-20){
          el.style.setProperty("bottom", "10px", "important");
          el.style.setProperty("top", "inherit", "important");
        }else{
          pos = this.props.topPos - moveUp;
          el.style.setProperty("top", pos+"px", "important");
        }

      }
    }
  }
  render(){
    const props = this.props;
    return (
      <div  id={`info${props.momKey}`} className={`infoContent ${props.largeDivClass} ${props.reference? 'referenceModal':''} w3-dropdown-content w3-animate-zoom w3-panel w3-${props.popupColor} w3-border w3-round-xlarge `} ref={ (divElement) => this.modalElement = divElement}>
        {props.children}
      </div>
    )

  }
}

class MouseOverModal extends React.Component {

  constructor(props) {
    super(props);
    

    this.state = {
      modalTop: 20,
      display:false
    };

  }

  
  referenceModalPositioner = (event, id)=>{
    const mouseHeight = event.clientY
    this.setState({modalTop:mouseHeight, display:true});
  }

  render(){
    return (
      <div  className={`mouseOverModal  ${this.props.floating==='left'? 'w3-left':''} ${this.props.floating==='right'? 'w3-right':''} ${this.props.isMobile?'w3-dropdown-click': 'w3-dropdown-hover'}`} onClick={this.props.open} onMouseLeave={()=>{this.setState({display:false});}} onMouseOver={(e)=>{this.referenceModalPositioner(e,this.props.momKey)}}><i className={`fa fa-info-circle  fa-fw w3-text-${this.props.infoColor}`}></i>
        {this.state.display&&
          <DisplayModal {...this.props} topPos={this.state.modalTop}>
            {this.props.children}
          </DisplayModal>
        }
      </div>
    )
  }
}

MouseOverModal.defaultProps = {
  infoColor: 'blue',
  popupColor: 'yellow',
}

const TechnologyWork = props => (
      <div>

      <div className={`w3-container`}>
          <h5 className={`w3-opacity`}><b>Senior Software Engineer - <a href="http://otter.ai" target="new_otter">Otter.ai</a></b></h5>
          <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2021-current</h6>
          <p>As part of the front end team at Otter, we build the web interface for Otter's awesome transcription platform.  I joined Otter as it is the best transcription software I have ever found, and am proud to be making it even more user friendly, work even better for corporate teams, as well as adding polish and design touches to make it feel more amazing.           </p>
          <hr />
        </div>
      <div className={`w3-container`}>
          <h5 className={`w3-opacity`}><b>Senior Software Engineer - <a href="http://google.com" target="new_google">Google</a></b></h5>
          <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2019-2020</h6>
          <p>Working on the <a href="https://www.youtube.com/livestreaming">Youtube Live</a> streaming experience, helping creators to stream video in real time. I have been driving a more intuitive onboarding user journey. This was luckily done right before the COVID lockdowns, improving the experience for a surge of new users.  I have also run a number of weekly workshops for Googlers on topics like mindfulness, relaxation, and cultivating mindsets to help us thrive in our working and personal lives. I have received a number of accolades for these workshops.
          </p>
          <hr />
        </div>
        <div className={`w3-container`}>
          <h5 className={`w3-opacity`}><b>Senior Frontend Engineer - <a href="http://kivu.tech" target="new_kivu">Kivu Technologies</a></b></h5>
          <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2017-2018</h6>
          <p>I built the frontend interface for Kivu's flagship product, focussing on great user experiences for our customers, with smooth investigation tools, to provide intuitive access to insights and intelligence.  This was built mostly with d3JS, canvas, AngularJS and LeafletJS. In this role I started as the sole front end engineer for the first 9 months, and over the next year built out a team of 5 on the front end. In this role I mentored and trained a number of the team.</p>
          <hr />
        </div>

        {/*<div className={`w3-container`}>
          <h5 className={`w3-opacity`}><b>Senior Engineer - <a href="http://meme-trainer.herokuapp.com" target="new_mt">Meme Trainer</a></b></h5>
          <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2017</h6>
          <p>I created Meme Trainer as a project to inspire people to create habits and feeling to enrich their lives and the world.  The project is built using Meteor, React and Reveal. Development stopped once I started at Kivu.</p>
          <hr />
        </div>*/}
        
        <div className={`w3-container`}>
          <h5 className={`w3-opacity`}><b>Full Stack Engineer - <a href="http://thedistillery.co/" target="new_dist"> The Distillery Co.</a></b></h5>
          <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2014</h6>
          <p>Working on PuntClub - a symfony2 php project, I worked closely with the lead developer to release multiple whitelabels of the product. Our tech suite: hg, AWS, selenium&phpUnit, linux, vim, magePhp, rabbitMQ.<br/>
            Working closely with our Managing Director and Founder & CEO of PuntClub, we also engaged with our large corporate client as we launched the white label instances. I also helped managed our outsourced overseas programming team. 
            I ran a few office yoga sessions as well.            
            </p>
          <hr />
        </div>

        <div className={`w3-container`}>
          <h5 className={`w3-opacity`}><b>Senior Engineer - <a href="http://butler-bowdon.com" target="new_bb">butler-bowdon.com</a></b></h5>
          <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2004 - 2008</h6>
          <p>In 2008, I rebuilt butler-bowdon.com in symfony.  Using the code I had developed on c4d I ported the old static html site to a cms. I engaged the skills of a designer for 2 css templates, but implemented the rest myself.<br />
          Prior to this I had edited and consulted on the static html website over a number of years.
          </p>
          <hr />
        </div>

        <div className={`w3-container`}>
          <h5 className={`w3-opacity`}><b>Ismar08 International Symposium on Mixed and Augmented Reality</b></h5>
          <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2008</h6>
          <p>The 2008 symposium was held at Cambridge university. I held the volunteer position Greeting, Support and Logistics.</p>
          <hr />
        </div>

        <div className={`w3-container`}>
          <h5 className={`w3-opacity`}><b>Senior Engineer - c4d.org</b></h5>
          <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2007</h6>
          <p>Built c4d.org in Symfony. Using the SimpleCMS plugin I created a cms platform for the Communication For Development team.</p>
          <hr />
        </div>

        <div className={`w3-container`}>
          <h5 className={`w3-opacity`}><b>Web Engineer -  Transmogrifier E-Solutions</b></h5>
          <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2003 & 2006</h6>
          <p>Transmogrifier E-Solutions - transmog.com.au known as  BennoWeb.com.au in 2003.<br />
            Transmogrifier was a dedicated ethical development house, only developing for organizations that helped individuals and society. 
            I worked on multiple websites for government, corporate and community organizations, delivering the functionality using in-house php development tools and mysql.
            I was a major contributor to <a href="https://www.karmabunny.com.au/what_we_do/content_management" target="_kb">SproutCMS</a> that is still used. 
            My role was to create all of the site functionality and to match the designers required html exactly.</p>
            
          <hr />
        </div>
      
        <div className={`w3-container`}>
          <h5 className={`w3-opacity`}><b><a href="http://earthrepair.net/" target="new_erf">Earth Repair Foundation</a></b></h5>
          <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2005</h6>
          <p>I provided web design and IT support as well as education, wellbeing, and environmental projects</p>
          <hr />
        </div>

        <div className={`w3-container`}>
          <h5 className={`w3-opacity`}><b>ComIT</b></h5>
          <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2004</h6>
          <p>Recycling & rebuilding computers for charities. We would tear out each component, test them, then rebuild. The new systems would then have Linux installed and shipped to third world projects</p>
          <hr />
        </div>

      </div>
);


const EducationWork = props => (
  <div className={`w3-container`}>
    <div className={`w3-container`}>
      <h5 className={`w3-opacity`}><b>Flinders University Tutor</b></h5>
      <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2000-2002</h6>
      <p>Computer programming subjects in Java, c, csh.</p>
      <hr />
    </div>
    <div className={`w3-container privateTutoring`}>
      <h5 className={`w3-opacity`}><b>Private Tutoring</b></h5>
      <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2001-2002</h6>computer programming<br />
      <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>1997-2013</h6>High school Mathematics yr 8-12<br />
      <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2012-2013</h6>Human physiology, physics, chemistry yr 11-12<br />
      <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2013-2016</h6>English<br />
      
      <hr />
    </div>
    <div className={`w3-container seminars`}>
      <h5 className={`w3-opacity`}><b>Seminars</b></h5>
      <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>1997-2018</h6>Mnemonics<br />
      <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2006-2018</h6>Yoga<br />
      <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2001-2018</h6>Laughter<br />
      <hr />
    </div>

    <div className={`w3-container`}>
      <h5 className={`w3-opacity`}><b>Ran in the Australian Federal Election</b></h5>
      <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2013</h6>
      <p><a href="http://www.voteplanet.net/federal-election-2013.html">Our Platform</a><br/>
          <a href="https://oursay.org/user/frazer-kirkman-1">Some of my public statements</a><br/>
          This campaign was largely for public education.
      </p>
      <hr />
    </div>

        
  </div>
);


const WellnessWork = props => (
  <div>

    <h1>Frazer Kirkman Coaching</h1>
    <div className={`w3-container`}>
      <p>An ongoing passion throughout my life is empowering people to transform and thrive.  I have ran my own ventures as a self empowerment coach and workshop presenter.<br/> <a href="http://frazerk.net/">Here is my coaching website</a>.</p>
      <hr />
    </div>

      
    <div className={`w3-container`}>
      <h5 className={`w3-opacity`}><b>Founder and lead faciltator of Vienna team awesome</b></h5>
      <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>October 2017 - 2019</h6>
      <p>During my last 8 months in Vienna I grew a group meditation group from once a week up to six times a week, at our peak with 30 people attending each workshop.</p>
      <p><a href="https://www.facebook.com/groups/yogavienna/">Team Awesome Vienna</a> continued to run for six months after I left, by a team that I had trained.</p>
      <p>With over 500 members, it held mindfulness, compassion and metaphor meditations, as well as laughter workshops, free-hugs, and picnics and parties.</p>
      <hr />
    </div>

    
    <div className={`w3-container`}>
      <h5 className={`w3-opacity`}><b>Project advisor and workshop presenter</b></h5>
      <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>Feb 2016 - July 2016</h6>
      <p>I spent 6 months in China, advising on 蝴蝶湾 (Húdié wān), the Butterfly Bay Lifestyle Club based in Shanghai and ZhuJiaJian.  Some of our offerings <a href="http://frazerk.net/bb/">can be seen here</a>.</p>
      <p>During this project I ran multiple workshops for a variety of client types, was part of the tendering process for corporate clients, as well as managing the Shanghai restaurant, and being part of the design and opening of 3 new resorts.</p>
      <p>As well as experience from the project I benefitted by learning about how business is conducted in China, practicing my chinese language skills, and being immersed in chinese culture.</p>
      <hr />
    </div>


    <div className={`w3-container`}>
      <h5 className={`w3-opacity`}><b>Creator and Manager of Eden Sanctuary</b></h5>
      <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2011-2013</h6>
      <p>See <a href="https://www.facebook.com/EdenSanctuaryAdelaide">facebook.com/EdenSanctuaryAdelaide</a></p>
      <p>I managed this wellness center with up to 30 guests at a time. We held daily workshops and exercise sessions.</p>
    </div>
    

    <div className={`w3-container`}>
      <h5 className={`w3-opacity`}><b>Oxford University - Corpus Christi College</b></h5>
      <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2009</h6>
      <p>I held compassion and empowerment meditations for over 50 sessions over 6 months in the college chapel.</p>
    </div>

    <div className={`w3-container`}>
      <h5 className={`w3-opacity`}><b>Confest</b></h5>
      <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2003 - 2015</h6>
      <p><a href="http://confest.org.au">Confest</a> is a wonderful bi-annual festival in Australia. I ran multiple workshops each day, some days up to 16 hours straight.  A few years my workshops had over 1400 participants in total.</p>
    </div>

    <div className={`w3-container`}>
      <div>More <MouseOverModal open={() => props.infoClickFunction('wellnessMore',props.isMobile)} momKey={'wellnessMore'} largeDivClass={' largeInfoDiv'} isMobile={props.isMobile} infoColor={`green`} floating={`left`}>
      2013 - 2015 We Love Life festival <br/>
      - Presenter and team member <br/>
        <br/>
      2005 <a href="http://earthrepair.net">Earth Repair Foundation </a><br/>
       - Meditation, Community development, Ecological projects, Web design, IT support<br/>
        <br/>
      2000-1 Alpha empowerment seminars<br/>
       - I assisted during the Adelaide workshops of the self empowerment 3 day seminars<br/>
        <br/>
      1996 - 99 City of Marion Youth Development Team:<br/>
         Beyond Imagination 3 day Program Team leader<br/>
         Sister cities ambassador<br/>
         <br/>
      1999-2001 Self Development Society of Flinders Uni. (Founder & President)<br/>
      1999-2001 RYLA - Rotary Youth Leadership Retreat - Team leader
      </MouseOverModal></div>
    </div>

    <div className={`w3-container`}>
      <div>Entertainment <MouseOverModal open={() => props.infoClickFunction('wellnessEntertain',props.isMobile)} largeDivClass={' largeInfoDiv'} momKey={'wellnessEntertain'}  isMobile={props.isMobile} infoColor={`green`} floating={`left`}>

    <a href="https://www.youtube.com/watch?v=MarK3ml2fE0">My happiness mission</a><br />
    <a href="http://www.weekendnotes.com/the-laughing-room/">The Laughing room</a><br />
    <a href="http://www.adelaidenow.com.au/lifestyle/sa-lifestyle/random-acts-of-kindness/news-story/31b3b337b62aa5d28017ed9867457b82">Kindness in the Adelaide News</a><br /><br />


    2005 Mythopeioa festival space coordinator<br />
    2004-2005 Rainbow Serpent Personal development space assistant, workshop facilitator<br />
    2004 Earthdance Ambassador<br />
    1999 Youth Arts Artery Party Organising Committee<br />
    1998-99 Weekly performer at Rhino Room,<br /> -  as Frazer The Mind Magician<br />
    1997-1999 Games Facilitator & Children’s Clown - Games Unlimited<br />
        - Performed at major festival such as Glendi and Fringe.
    
      </MouseOverModal></div>
    </div>


  </div>
);

class WorkExperience extends React.Component {
  constructor(props) {
    super(props);
    

    this.state = {
      pageSelected: 'technology',
    };

  }
  isActive(value){
    return ((value===this.state.pageSelected) ?'experiencePaneActive':'');
  }

  changePage(page){
    this.setState({pageSelected: page,});
  }
  // renderJobs() {
  //   let filteredJobs = [];

  //   if(filteredJobs.length){

  //     this.noJobsInCurrentView = false;
  //     this.JobsDue = 0;
  //     return filteredJobs.map((meme) => {

  //       if(meme.active && meme.isDue) this.JobsDue++;
  //       return (
  //         <Job
  //           key={meme._id}
  //           meme={meme}/>
  //       );
  //     });
  //   }
  // }

 
  render() {
    return (
      <div id="experience" className={`w3-container w3-card-2 w3-white w3-margin-bottom`}>
        <h2 className={`w3-text-grey w3-padding-16`}><i className={`fa fa-suitcase fa-fw w3-margin-right w3-xxlarge w3-text-teal`}></i>Work Experience</h2>
        
        <ul className={`w3-navbar  experienceTabs`}>
          <li className={`experienceTab experienceTechnology ${this.isActive('technology')} `} onClick={this.changePage.bind(this,'technology')} ><h2 className={`w3-text-grey experienceTabText`}><i className={`fa fa-desktop fa-fw w3-margin-left w3-large w3-text-teal`}></i><span className={`navTexts`}>Technology</span></h2></li>  
          <li className={`experienceTab experienceEducation ${this.isActive('education')} `} onClick={this.changePage.bind(this,'education')} ><h2 className={`w3-text-grey experienceTabText`}><i className={`fa fa-graduation-cap fa-fw w3-margin-left w3-large w3-text-teal`}></i><span className={`navTexts`}>Teaching</span></h2></li>  
          <li className={`experienceTab experienceWellness ${this.isActive('wellness')} `} onClick={this.changePage.bind(this,'wellness')} ><h2 className={`w3-text-grey experienceTabText`}><i className={`fa fa-smile-o fa-fw w3-margin-left w3-large w3-text-teal`}></i><span className={`navTexts`}>Wellness</span></h2></li>  
        </ul>
        <Waypoint  onEnter={() => this.props.setPage('experience')}/>

        <div className={`experienceContainer`}>
          <div className={`w3-container experiencePane  experienceTechnology ${this.isActive('technology')} `} onClick={this.changePage.bind(this,'technology')}>
            {this.isActive('technology') ? <TechnologyWork /> : ' ' }
          </div>
          
          <div className={`w3-container experiencePane experienceEducation ${this.isActive('education')} `} onClick={this.changePage.bind(this,'education')}>
            {this.isActive('education') ? <EducationWork /> : ' ' }
          </div>

          <div className={`w3-container experiencePane experienceWellness ${this.isActive('wellness')} `} onClick={this.changePage.bind(this,'wellness')}>
            {this.isActive('wellness') ? <WellnessWork infoClickFunction={this.props.infoClickFunction} isMobile={this.props.isMobile} /> : ' ' }
          </div>
        </div>
        <Waypoint  onEnter={() => this.props.setPage('experience')}  topOffset="50px"/>
        
      </div>
    );
  }
}



class Skills extends React.Component {
  constructor(props) {
    super(props);
    

    this.state = {
    };

  }

 
  render() {
    return (
    <div id="skills" className={`w3-container w3-card-2 w3-white w3-margin-bottom`}>
      <h2 className={`w3-text-grey w3-padding-16`}><i className={`fa fa-globe fa-fw w3-margin-right w3-xxlarge w3-text-teal`}></i>Skills</h2>

        <p className={`w3-large w3-text-theme`}><b><i className={`fa fa-desktop fa-fw w3-margin-right w3-text-teal`}></i>Development</b></p>

        <table className={`w3-table skillsTable displaySkillsTable w3-border`} >
          <tbody>
          
            <tr className={`skillTableOddSkill`}>
              <td rowSpan={`6`} className={`skillTableHeaderOdd`}>Display</td><td>Html<div className={`infoCircle w3-right greenCircle`}></div></td></tr>
              <tr className={`skillTableOddSkill`}><td>w3.css<MouseOverModal open={() => this.props.infoClickFunction('w3css',this.props.isMobile)} momKey={'w3css'}  isMobile={this.props.isMobile} infoColor={`green`} floating={`right`}>This whole resume is built on w3.css</MouseOverModal></td></tr>
              <tr className={`skillTableOddSkill`}><td>scss/less<MouseOverModal open={() => this.props.infoClickFunction('scss',this.props.isMobile)} momKey={'scss'}  isMobile={this.props.isMobile} infoColor={`green`} floating={`right`}>I love intelligent hierarchy.</MouseOverModal></td></tr>
              <tr className={`skillTableOddSkill`}><td>bootstrap<MouseOverModal open={() => this.props.infoClickFunction('bootstrap',this.props.isMobile)} momKey={'bootstrap'}  isMobile={this.props.isMobile} infoColor={`yellow`} floating={`right`}>For site design, I would prefer to work with a designer.</MouseOverModal></td></tr>
              <tr className={`skillTableOddSkill`}><td>Css<MouseOverModal open={() => this.props.infoClickFunction('css',this.props.isMobile)} momKey={'css'}  isMobile={this.props.isMobile} infoColor={`yellow`} floating={`right`}>I can do some nice things. For site design, I would prefer to work with a designer.</MouseOverModal></td></tr>
              <tr className={`skillTableOddSkill`}><td>UX design<MouseOverModal open={() => this.props.infoClickFunction('css',this.props.isMobile)} momKey={'ux'}  isMobile={this.props.isMobile} infoColor={`yellow`} floating={`right`}>With my Cognitive Science training, I create designs and interfaces for maximum ease and engagement for the users.</MouseOverModal></td></tr>
          </tbody>
        </table>

        <table className={`w3-table skillsTable w3-border`} >
          <tbody>
            <tr className={`skillTableEvenSkill`}>
              <td  rowSpan={`6`} className={`skillTableHeaderEven`}>Front&nbsp;end</td><td>Javascript<MouseOverModal open={() => this.props.infoClickFunction('js',this.props.isMobile)} momKey={'js'}  isMobile={this.props.isMobile} infoColor={`green`} floating={`right`}>I love javascript.</MouseOverModal></td></tr>
              <tr className={`skillTableEvenSkill`}><td>AngularJS<MouseOverModal open={() => this.props.infoClickFunction('angular',this.props.isMobile)} momKey={'angular'}  isMobile={this.props.isMobile} infoColor={`green`} floating={`right`}>I have consulted and programmed with 2 large startups on their angular sites. I also helped on a small charity project based on angular.</MouseOverModal></td></tr>
              <tr className={`skillTableEvenSkill`}><td>D3<MouseOverModal open={() => this.props.infoClickFunction('d3',this.props.isMobile)} momKey={'d3'}  isMobile={this.props.isMobile} infoColor={`green`} floating={`right`}>D3 is a great tool for data visualization.</MouseOverModal></td></tr>
              <tr className={`skillTableEvenSkill`}><td>React<MouseOverModal open={() => this.props.infoClickFunction('react',this.props.isMobile)} momKey={'react'}  isMobile={this.props.isMobile} infoColor={`green`} floating={`right`}>This whole resume is built with React.</MouseOverModal></td></tr>
              <tr className={`skillTableEvenSkill`}><td>Meteor<MouseOverModal open={() => this.props.infoClickFunction('meteor',this.props.isMobile)} momKey={'meteor'}  isMobile={this.props.isMobile} infoColor={`green`} floating={`right`}>A fullstack node javascript framework - sockets to the extreme.</MouseOverModal></td></tr>
              <tr className={`skillTableEvenSkill`}><td>jQuery<div className={`infoCircle w3-right yellowGreenCircle`} /></td></tr>
          </tbody>
        </table>

        <Waypoint  onEnter={() => this.props.setPage('skills')}/>

        <table className={`w3-table skillsTable dbTable w3-border`}>
          <tbody>
            <tr className={`skillTableEvenSkill`}>
              <td  rowSpan={`2`} className={`skillTableHeaderEven`}>DB</td><td>mysql  <div className={`infoCircle w3-right greenCircle`} /></td></tr>
              <tr className={`skillTableEvenSkill`}><td>mongoDB <div className={`infoCircle w3-right greenCircle`} /></td></tr>
          </tbody>
        </table>

        <table className={`w3-table skillsTable w3-border`} style={{clear: 'both'}}>
          <tbody>
            <tr className={`skillTableEvenSkill`} >
              <td rowSpan={`6`}  className={`skillTableHeaderEven`}>Back&nbsp;end</td><td>Meteor<MouseOverModal open={() => this.props.infoClickFunction('meteorBackend',this.props.isMobile)} momKey={'meteorBackend'}  isMobile={this.props.isMobile} infoColor={`green`} floating={`right`}>I love how meteor manages everything - react module loading, hot data pushing across clients. I think it is magic.</MouseOverModal></td></tr>
              <tr  className={`skillTableEvenSkill`}><td>PHP<MouseOverModal open={() => this.props.infoClickFunction('php',this.props.isMobile)} momKey={'php'}  isMobile={this.props.isMobile} infoColor={`light-green`} floating={`right`}>Before 2015, most of my professional work was in PHP. Transmog, The Distillery, butler-bowdon.</MouseOverModal></td></tr>
              <tr  className={`skillTableEvenSkill`}><td>Symfony<MouseOverModal open={() => this.props.infoClickFunction('symfony',this.props.isMobile)} momKey={'symfony'}  isMobile={this.props.isMobile} infoColor={`yellow`} floating={`right`}>Symfony2:  The Distillery<br /> Symfony: Butler-bowdon.com and c4d.org</MouseOverModal></td></tr>
              <tr  className={`skillTableEvenSkill`}><td>Java<MouseOverModal open={() => this.props.infoClickFunction('Java',this.props.isMobile)} momKey={'Java'}  isMobile={this.props.isMobile} infoColor={`yellow`} floating={`right`}>Tutored at university.</MouseOverModal></td></tr>
              <tr  className={`skillTableEvenSkill`}><td>bash, csh<MouseOverModal open={() => this.props.infoClickFunction('bash',this.props.isMobile)} momKey={'bash'}  isMobile={this.props.isMobile} infoColor={`yellow`} floating={`right`}>Tutored at university, and use them regularly.</MouseOverModal></td></tr>
              <tr  className={`skillTableEvenSkill`}><td>more<MouseOverModal open={() => this.props.infoClickFunction('moreBackend',this.props.isMobile)} momKey={'moreBackend'} infoColor={`deep-orange`} isMobile={this.props.isMobile}  floating={`right`}>c, c++<br/>Drupal<br/>python<br/>ruby, rails</MouseOverModal></td></tr>
          </tbody>
        </table>

        <table className={`w3-table skillsTable w3-border`} >
          <tbody>
            <tr className={`skillTableOddSkill`} >
              <td rowSpan={`6`}  className={`skillTableHeaderOdd`}>Behind the scenes</td><td>git<MouseOverModal open={() => this.props.infoClickFunction('git',this.props.isMobile)} momKey={'git'}  isMobile={this.props.isMobile} infoColor={`green`} floating={`right`}>Check out <a href="https://frazer.github.io/portfolio/">My github page</a></MouseOverModal></td></tr>
              <tr  className={`skillTableOddSkill`} ><td>regex<MouseOverModal open={() => this.props.infoClickFunction('regex',this.props.isMobile)} momKey={'regex'}  isMobile={this.props.isMobile} infoColor={`green`} floating={`right`}>You need data massaged, I will do it.</MouseOverModal></td></tr>
              <tr  className={`skillTableOddSkill`} ><td>vim<div className={`infoCircle w3-right greenCircle`} /></td></tr>
              <tr  className={`skillTableOddSkill`} ><td>ssh<div className={`infoCircle w3-right greenCircle`} /></td></tr>
              <tr  className={`skillTableOddSkill`} ><td>more <MouseOverModal open={() => this.props.infoClickFunction('moreBehind',this.props.isMobile)} momKey={'moreBehind'}  isMobile={this.props.isMobile} infoColor={`orange`} floating={`right`}>Linux/Mac/Windows, AWS, deployment, vagrant, Mobile:(Meteor,Phonegap), mail servers, Apache.</MouseOverModal></td></tr>
              <tr  className={`skillTableOddSkill`} ><td>testing <MouseOverModal open={() => this.props.infoClickFunction('testing',this.props.isMobile)} momKey={'testing'} infoColor={`deep-orange`} isMobile={this.props.isMobile}  floating={`right`}>I need to practice TDD.</MouseOverModal></td></tr>
          </tbody>
        </table>
      <div style={{clear: 'both'}} />

      <div className={`w3-container`}>
        <p className={`w3-large w3-text-theme`}><b><i className={`fa fa-globe fa-fw w3-margin-right w3-text-teal`}></i>Languages</b></p>
        <div  style={{float:'left',marginBottom:'4px'}}>English</div>
        <div className={`w3-progress-container w3-round-xlarge`} style={{float:'right', width:'50%',marginBottom:'4px'}}>
          <div className={`w3-progressbar w3-round-xlarge w3-teal`} style={{width:'98%',}}><div className={`w3-center w3-text-white`}>Native</div></div>            
        </div>
        <div  style={{clear:"both", float:'left',marginBottom:'4px'}}>German, Chinese Mandarin</div>
        <div className={`w3-progress-container w3-round-xlarge`} style={{float:'right', width:'50%',marginBottom:'4px'}}>
          <div className={`w3-progressbar w3-round-xlarge w3-teal`} style={{width:'25%',}}> 
            <div className={`w3-center w3-text-white`}>A1-A2</div>
          </div>
        </div>
        {/*<div  style={{clear:"both", float:'left',marginBottom:'4px' }}>Spanish</div>
        <div className={`w3-progress-container w3-round-xlarge`} style={{float:'right', width:'50%',marginBottom:'4px'}}>
          <div className={`w3-progressbar w3-round-xlarge w3-teal`} style={{width:'15%',}}></div>
        </div>*/}
        
      </div>

      <Waypoint  onEnter={() => this.props.setPage('skills')}/>
        
      <div className={`w3-container`}>
        <p className={`w3-large w3-text-theme`}><b><i className={`fa fa-magic fa-fw w3-margin-right w3-text-teal`}></i>But wait, there is more</b></p>

    
        <table className={`w3-table skillsTable moreSkillsTable skillTableEvenSkill w3-border`}>
          {(this.props.screenWidth>565)? <tbody>
            <tr className={`skillTableEvenSkill`}>
              <td>Mathematical and logical<div className={`infoCircle w3-right greenCircle`} /><br/>Teaching / tutoring<div className={`infoCircle w3-right greenCircle`} /><br/>Problem Solver<div className={`infoCircle w3-right greenCircle`} /><br/>Debugging<div className={`infoCircle w3-right yellowGreenCircle`} /></td>
              <td>Image editing<div className={`infoCircle w3-right greenCircle`} /><br/>Sound editing<div className={`infoCircle w3-right greenCircle`} /><br/>Video editing<div className={`infoCircle w3-right greenCircle`} /></td></tr>
            <tr className={`skillTableEvenSkill`}>
              <td>Coaching<div className={`infoCircle w3-right greenCircle`} /><br/>Public Speaking<div className={`infoCircle w3-right greenCircle`} /><br/>Mindfulness training<div className={`infoCircle w3-right greenCircle`} /><br/>Behavioural Transformation<MouseOverModal open={() => this.props.infoClickFunction('brainProgram',this.props.isMobile)} momKey={'brainProgram'}  isMobile={this.props.isMobile} infoColor={`green`} floating={`right`}>Memetic Engineering</MouseOverModal></td>
              <td>Team Building<div className={`infoCircle w3-right greenCircle`} /><br/>Group facilitation<div className={`infoCircle w3-right greenCircle`} /><br/>
        Conflict Resolution<div className={`infoCircle w3-right yellowGreenCircle`} /></td>
           </tr>
          </tbody>
          :
          <tbody>
            <tr className={`skillTableEvenSkill`}>
              <td>Mathematical and logical<div className={`infoCircle w3-right greenCircle`} /><br/>Teaching / tutoring<div className={`infoCircle w3-right greenCircle`} /><br/>Problem Solver<div className={`infoCircle w3-right greenCircle`} /><br/>Debugging<div className={`infoCircle w3-right yellowGreenCircle`} /></td></tr>
            <tr className={`skillTableEvenSkill`}>
              <td>Image editing<div className={`infoCircle w3-right greenCircle`} /><br/>Sound editing<div className={`infoCircle w3-right greenCircle`} /><br/>Video editing<div className={`infoCircle w3-right greenCircle`} /></td></tr>
            <tr className={`skillTableEvenSkill`}>
              <td>Coaching<div className={`infoCircle w3-right greenCircle`} /><br/>Public Speaking<div className={`infoCircle w3-right greenCircle`} /><br/>Mindfulness training<div className={`infoCircle w3-right greenCircle`} /><br/>Behavioural Transformation<MouseOverModal open={() => this.props.infoClickFunction('brainProgram',this.props.isMobile)} momKey={'brainProgram'}  isMobile={this.props.isMobile} infoColor={`green`} floating={`right`}>Memetic Engineering</MouseOverModal></td></tr>
            <tr className={`skillTableEvenSkill`}>
              <td>Team Building<div className={`infoCircle w3-right greenCircle`} /><br/>Group facilitation<div className={`infoCircle w3-right greenCircle`} /><br/>
        Conflict Resolution<div className={`infoCircle w3-right yellowGreenCircle`} /></td>
           </tr>
          </tbody>
        }
        </table>

        <br />
        <br />
      </div>
      <br />
    </div>
    );
  }
}


class References extends React.Component {
  constructor(props) {
    super(props);
    

    this.state = {
    };

  }

 
  render() {
    return (
     <div id="references" className={`w3-container w3-card-2 w3-white w3-margin-bottom`}>
      <h2 className={`w3-text-grey w3-padding-16`}><i className={`fa fa-send-o fa-fw w3-margin-right w3-xxlarge w3-text-teal`}></i>References</h2> 
      <div className={`w3-container`}>
        
        <div className={`w3-container w3-center`}>

          <h3>Christian Weichselbaum
            <MouseOverModal open={() => this.props.infoClickFunction('weichselbaumReference',this.props.isMobile)}  momKey={'weichselbaumReference'}  isMobile={this.props.isMobile} infoColor={`yellow`} reference={true}>
              Frazer was a Senior Frontend Developer at KIVU. He was responsible for building our innovative customer interface. He drove the development of our graph visualisation and was quite innovative when combining D3.js and canvas in order to allow for a significant performance increase. <br/><br/>
              In that development process Frazer has shown a love for detail and perfection and hence created a very pleasant user experience. Frazer has been the key developer in the overall Frontend implementation. His work stretched far beyond D3.js and deep into working with the Angular.js framework. <br/><br/>
              At KIVU, we are constantly striving towards good coding practices and a leaner, cleaner code base. I have enjoyed working closely with Frazer to master Angular.js for this purpose.   Whilst working for KIVU, Frazer went out of his way to do overtime when it was required and always put in extra effort to improve the codebase. <br/><br/>
              In KIVU sponsored meetups he presented well and showed outstanding teaching skills. He always offered less technical colleagues assistance if needed, and was eager to understand the business in depth to work out visualisation solutions. Frazer taught the team much about effective altruism and saving important resources, values which are important to him. <br/><br/>
              Frazer is a strong independent worker, who responds well to praise and recognition from the team and was quick to support other team members and offer his opinions on their work.   Frazer is a talented developer and relishes new visualisation challenges.  Please do not hesitate to contact me if you need any further information.
            </MouseOverModal>
          </h3>
          <p>Managing Director, CTO, Co-Founder at KIVU Technologies (GmbH)<br />
          <a href="mailto:christian@kivu.tech?Subject=Reference%20for%20Frazer%20Kirkman" target="_top">christian@kivu.tech</a></p>
          
          <Waypoint  onEnter={() => this.props.setPage('references')}/>
          
          
          <h3>Robert Wesley
            <MouseOverModal open={() => this.props.infoClickFunction('wesleyReference',this.props.isMobile)}  momKey={'wesleyReference'}  isMobile={this.props.isMobile} infoColor={`yellow`} reference={true}>
              We are very fortunate to have had Frazer on our team.<br/>
              He was instrumental in the creation of our brilliant user interface.<br/>
              His work was featured when we appeared in "The Maze", <br/>
              which was nominated for the Grimme-Preis, <br/>
              the most prestigious TV award in Germany.  <br/><br/>
              He has shown hard work, dedication, creativity, positive energy and problem-solving skills, which have been an invaluable part of our company. Not to mention his dedication to honesty, reliability, openness, and loyalty.  <br/><br/>
              He has increasingly taken on management tasks, so as his team grew he contributed to a great team culture. As well as his professionalism and proficiency, he brought something intangible to our office, a sense of enthusiasm and well being that was contagious.  <br/><br/>
              When he has taught other team members new skills, they adapted very quickly, so I can only assume his training abilities are exceptional. Also, many of our conversations have been personally inspiring to me as Frazer shared his thoughts and attitudes.  I can't recommend him highly enough.
            </MouseOverModal>
          </h3>
          <p>Founder at KIVU Technologies (GmbH)<br />
          <a href="mailto:wesley@kivu.tech?Subject=Reference%20for%20Frazer%20Kirkman" target="_top">wesley@kivu.tech</a></p>
          
          <h3>Jason Neave
            <MouseOverModal open={() => this.props.infoClickFunction('neaveReference',this.props.isMobile)}  momKey={'neaveReference'}  isMobile={this.props.isMobile} infoColor={`yellow`} reference={true}>
              Frazer worked with us on a fairly complex deployment of a white-label instance of our Punt Club social sportsbetting application. Not only was he a calming influence in the storm, he contributed some great ideas and even managed to squeeze in some morning yoga classes for the rest of the team. I'd recommend Frazer to anyone wanting a javascript frontend, or fullstack PHP developer with an entrepreneurial mindset and some life skills to help make your workplace a better place. He also contributed to UX development.
            </MouseOverModal>
          </h3>
          <p>CEO - The Distillery and Puntclub.com<br />
          <a href="mailto:jason.neave@puntclub.com?Subject=Reference%20for%20Frazer%20Kirkman" target="_top">jason.neave@puntclub.com</a></p>

          <h3>Ashley Simons</h3>
          <p>Lead developer - PuntClub.com<br />
          <a href="mailto:ashley.simons@puntclub.com?Subject=Reference%20for%20Frazer%20Kirkman" target="_top">ashley.simons@puntclub.com</a></p>

          <h3>Multiple people</h3>
          <p><a href="http://frazerk.net/#testimonials" target="fkhomepage">Have left testimonials</a><br/>
          from coaching and projects with me</p>

          <Waypoint  onEnter={() => this.props.setPage('references')}/>

          <h3>Franklin Scarf</h3>
          <p>Director - Earth Repair Foundation<br />
          <a href="./testimonial_img/EarthRepairReferenceForFrazer.pdf">Written testimonial</a><br/>
          <a href="mailto:franklin@earthrepair.net?Subject=Reference%20for%20Frazer%20Kirkman" target="_top">franklin@earthrepair.net</a></p>
          
        </div>
      </div>
    </div>      
    );
  }
}

class Education extends React.Component {
  constructor(props) {
    super(props);
    

    this.state = {
    };

  }

 
  render() {
    return (
    <div id="education" className={`w3-container w3-card-2 w3-white w3-margin-bottom`}>
      <h2 className={`w3-text-grey w3-padding-16`}><i className={`fa fa-graduation-cap fa-fw w3-margin-right w3-xxlarge w3-text-teal`}></i>Education</h2> 
          
          <div className={`w3-container`}>
            <h5 className={`w3-opacity`}><b>BSc. (Cognitive Science)</b></h5>
            <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>1999 - 2002</h6>
            <p>Flinders University Cognitive Science had a triple major of computer science, neuroscience, and psychology. I took the majority of my electives in computer science.
            We also took subjects in linguistics and philosophy.<br/>
            I received the Chancellor’s Letter of Commendation and was inducted in to the the
            Golden Key National Honours Society.</p>
            <hr />
          </div>
          <Waypoint  onEnter={() => this.props.setPage('education')}/>

          <div className={`w3-container`}>
            <h5 className={`w3-opacity`}><b>Small Business Management – Cert IV</b></h5>
            <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2011</h6>
            <p>The certificate IV is the highest certificate in Australia below the diploma</p>
            <hr />
          </div>
          <div className={`w3-container`}>
            <h5 className={`w3-opacity`}><b>Work Place Training and Assessment – Cert I</b></h5>
            <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>2002</h6>
            <p>Onkaparinga TAFE delivered this training in group facilitation and program design.</p>
            <hr />
          </div>
          <Waypoint  onEnter={() => this.props.setPage('education')}/>
          <div className={`w3-container`}>
            <h5 className={`w3-opacity`}><b>High school</b></h5>
            <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>1997</h6>
            <p>Eynesbury and Prince Alfred College</p>
            <p>Final Score: 94.7 / 99.75<br />
          Certificate of Merit - Maths 1 - stage 2<br />
          Certificate of Merit - Maths 2 - stage 1,2<br />
          SSABSA Math 1 Merit Award</p>
          <hr />
          </div>

          <div className={`w3-container`}>
            <h5 className={`w3-opacity`}><b>Young Achievement Aust. Business Skills Program</b></h5>
            <h6 className={`w3-text-teal`}><i className={`fa fa-calendar fa-fw w3-margin-right`}></i>1996</h6>
            <p>Marion Council Youth Business Team</p>
          </div>

    </div>
      );
  }
}

class Awards extends React.Component {
  constructor(props) {
    super(props);
    

    this.state = {
    };

  }

 
  render() {
    return (
      <div id="awards" className={`w3-container w3-card-2 w3-white w3-margin-bottom`}>
        <h2 className={`w3-text-grey w3-padding-16`}><i className={`fa fa-trophy fa-fw w3-margin-right w3-xxlarge w3-text-teal`}></i>Awards</h2>
        
        <div className={`w3-container`}>
          <Waypoint  onEnter={() => this.props.setPage('awards')}/>

          <pre> {`Programming:

  2014 CodeCombat Greed Programming competition
  15th place / 1132 entrants  

  2003 Google Code Jam
  Timed algorithm contest I came in the top 50 out of over 3000 participants

  2002 South Pacific Programming Contest - ACM
  Our team came 3rd in the state
          `}</pre>
          <Waypoint  onEnter={() => this.props.setPage('awards')}/>
          <div>More <MouseOverModal open={() => this.props.infoClickFunction('awardsMore',this.props.isMobile)} momKey={'awardsMore'} largeDivClass={' largeAwardsDiv'} isMobile={this.props.isMobile} infoColor={`green`} floating={`left`}>
          <pre> {` 
  High School Certificate:
    Certificate of Merit - Maths 1 - stage 2
    Certificate of Merit - Maths 2 - stage 1,2
    SSABSA Math 1 Merit Award

  Australian Nation Wide Competitions

  Mathematics Highlights:

    1997 AMOC - Uni of Canberra - Senior Div.
      High Distinction
    1997 MASA - IBM - Senior Section
      Distinction
    1996 MASA - IBM - Senior Section
      12th Place in South Australia
    1995 AMOC - University of Canberra
      Certificate of Excellence`}</pre>
     </MouseOverModal></div>
     <div>Even More <MouseOverModal open={() => this.props.infoClickFunction('awardsEvenMore',this.props.isMobile)} momKey={'awardsEvenMore'} largeDivClass={' largeAwardsDiv'} isMobile={this.props.isMobile} infoColor={`green`} floating={`left`}>
          <pre> {` 
  Math:    
    1990  Uni of NSW -  High Distinction
    1991  Uni of NSW -  Distinction
    1992  Uni of NSW -  High Distinction
    1993  Uni of Canberra - Westpac - Distinction
    1994  Uni of Canberra - Westpac 
          - Intermediate Prize Winner
    1995  MASA - IBM - Junior Section Distinction
    1995  Uni of Canberra - Westpac - Distinction
    1995  AMOC - Uni of Canberra - Excellence
    1996  MASA - IBM - Senior Section 12th Place
    1997  MASA - IBM - Senior Section Distinction
    1997  AMOC - Uni of Canberra - High Distinction
  Science:
    1993  Uni of NSW - Yr. 8  Distinction
    1994  Uni of NSW - Yr. 9  High Distinction
    1995  Uni of NSW - Yr. 10 High Distinction
  Chemistry:
    1995  Royal Aust. Chem. Instit. - High Distinction
    1996  Uni of NSW - Distinction
    1997  Royal Aust. Chem. Instit. - High Distinction`}</pre>
          </MouseOverModal></div><br/>
        </div>
      </div>
    );
  }
}


class About extends React.Component {
  constructor(props) {
    super(props);
    

    this.state = {
    };

  }

 
  render() {
    return (
      <div id="about" className={`w3-container w3-card-2 w3-white w3-margin-bottom`}>
        <h2 className={`w3-text-grey w3-padding-16`}><i className={`fa fa-user fa-fw w3-margin-right w3-xxlarge w3-text-teal`}></i>About</h2> 
    
        <div className={`w3-container`}>
          <p>For a number of years I challenged myself to follow my passion coaching people to improve their mental algorithms, and to be more happy and compassionate. From 2016 I chose again to focus on my technology career, by working with Kivu, then Google and Ottar.ai. I am passioante about wellbeing, education, AR/VR and ML.</p>          
          <Waypoint  onEnter={() => this.props.setPage('about')}/>
          

          <div className={`aboutValues`}>
            <p><b>VALUES</b></p>
            <ul className={`simpleList`}>
                <li>Enthusiasm</li>
                <li>Teaching and Education</li>
                <li>Environmental Sustainability</li>
                <li>Openness to relate with anyone</li>
                <li>Community and individual empowerment</li>
                <li>Compassion and consideration for everyone</li>
                
            </ul>
          </div>
          <Waypoint  onEnter={() => this.props.setPage('about')}/>

          <div className={`aboutInterests`}>
            <p><b>INTERESTS</b></p>
            <ul  className={`simpleList`}>
              <li>Augmented reality and wearable computing</li>
              <li>Inspirational and educational media</li>
              <li>Ultimate Frisbee and fitness</li>
              <li>Community and socialising</li>
              <li>Music and Dance</li>
              <li>Philosophy</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}


// App component - represents the whole app
class App extends React.Component {
  constructor(props) {
    super(props);
    

    this.state = {
      pageSelected: 'profileCard',
    };

    
    this.isMobile = this.mobilecheck();

  }


  mobilecheck() {
      var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
  };


  infoClickFunction(key, isMobile) {
    // console.log(e.target);
    if(isMobile){
      var x = document.getElementById("info"+key);
      if (x.className.indexOf("w3-show") === -1){
          x.className += " w3-show";
          function removeMOM(event) {
            x.className = x.className.replace(" w3-show", "");
            window.removeEventListener('click', removeMOM);
          }
          setTimeout(function(){ window.addEventListener('click', removeMOM); }, 50);
      }else{
          x.className = x.className.replace(" w3-show", "");
      }
    }
  }


  changePage(page){

    var documentElement = document.documentElement,
        body = document.getElementsByTagName('body')[0],
        width = window.innerWidth || documentElement.clientWidth || body.clientWidth;

      if ( width < 829 || page!=='profileCard'  ){
        this.setState({pageSelected: page,});
      }
    // document.getElementById(page).scrollIntoView(true);
    // if(this.state.width>829){
    //   this.offsetAnchor(60);  
    // }else{
    //   this.offsetAnchor(10);  
    // }
  }

  // offsetAnchor(distance) {
  //       var x,y;
  //       if (self.pageYOffset) // all except Explorer
  //       {
  //         x = self.pageXOffset;
  //         y = self.pageYOffset;
  //       }
  //       else if (document.documentElement && document.documentElement.scrollTop)
  //         // Explorer 6 Strict
  //       {
  //         x = document.documentElement.scrollLeft;
  //         y = document.documentElement.scrollTop;
  //       }
  //       else if (document.body) // all other Explorers
  //       {
  //         x = document.body.scrollLeft;
  //         y = document.body.scrollTop;
  //       }
  //       window.scrollTo(x,y - distance);
  // }

  scrollToTop(){
    scroll.scrollToTop();
  }

  
  updateDimensions() {

    var w = window,
        d = document,
        documentElement = d.documentElement,
        body = d.getElementsByTagName('body')[0],
        width = w.innerWidth || documentElement.clientWidth || body.clientWidth,
        height = w.innerHeight|| documentElement.clientHeight|| body.clientHeight;

        this.setState({width: width, height: height});
        // if you are using ES2015 I'm pretty sure you can do this: this.setState({width, height});
  }

  componentWillMount() {
        this.updateDimensions();
  }
  componentDidMount() {
      window.addEventListener("resize", this.updateDimensions.bind(this));

    var documentElement = document.documentElement,
        body = document.getElementsByTagName('body')[0],
        width = window.innerWidth || documentElement.clientWidth || body.clientWidth;

      setTimeout ( () => {if (!(self.pageYOffset !== 0 ||  // all except Explorer
               (document.documentElement && document.documentElement.scrollTop !== 0)  || // Explorer 6 Strict
               (document.body && document.body.scrollTop !==0) // all other Explorers
             )  && width > 829
          ){
            this.setState({pageSelected: "experience",});

        }},100);

  }
  componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  isActive(value){
    return ((value===this.state.pageSelected) ?'active':'');
  }

  render() {

    this.wideScreen = this.state.width > 829;

    return (
      <div className={`resumePageContainer`}>
        {this.wideScreen ?
        <div className={`w3-top heading-grey w3-hide-small`} >

          <ul className={`w3-navbar w3-margin-left `}>
                <li className={`w3-navitem`}> &nbsp;  &nbsp; </li>

                <li className={`${this.isActive('experience')}`} ><Link to="experience" offset={-52} smooth={true} duration={1500} ><h2 className={`w3-text-grey`}><i className={`fa fa-suitcase fa-fw w3-margin-left w3-large w3-text-teal`}></i><span className={`navTexts`}>Experience</span></h2></Link></li>
                <li className={`${this.isActive('skills')}`}     ><Link to="skills" offset={-52} smooth={true} duration={1500} ><h2 className={`w3-text-grey`}><i className={`fa fa-globe fa-fw w3-margin-left w3-large w3-text-teal`}></i><span className={`navTexts skillsNavText`}>Skills</span></h2></Link></li>
                <li className={`${this.isActive('references')}`} ><Link to="references" offset={-52} smooth={true} duration={1500} ><h2 className={`w3-text-grey`}><i className={`fa fa-send-o fa-fw w3-margin-left w3-large w3-text-teal`}></i><span className={`navTexts`}>References</span></h2></Link></li>
                <li className={`${this.isActive('education')}`}  ><Link to="education" offset={-52} smooth={true} duration={1500} ><h2 className={`w3-text-grey`}><i className={`fa fa-graduation-cap fa-fw w3-margin-left w3-large w3-text-teal`}></i><span className={`navTexts educationNavText`}>Education</span></h2></Link></li>
                <li className={`${this.isActive('awards')}`}     ><Link to="awards" offset={-52} smooth={true} duration={1500} ><h2 className={`w3-text-grey`}><i className={`fa fa-trophy fa-fw w3-margin-left w3-large w3-text-teal`}></i><span className={`navTexts  awardsNavText`}>Awards</span></h2></Link></li>
                <li className={`${this.isActive('about')}`}      ><Link to="about" offset={-52} smooth={true} duration={1500} ><h2 className={`w3-text-grey`}><i className={`fa fa-user fa-fw w3-margin-left w3-large w3-text-teal`}></i><span className={`navTexts`}>About</span></h2></Link></li>

                <li className={`  w3-right homeLink`}><a href="http://frazerk.net" target="home"><h2 className={`w3-text-grey  `}><i className={`fa fa-home fa-fw w3-large w3-text-teal`}></i> &nbsp; </h2></a></li>
                <li className={`  w3-right `}><a href="http://frazerk.net/resume.pdf" target="resumepdf"> <h2 className={`w3-text-grey  `}><i className={`fa fa-print fa-fw w3-large w3-text-teal`}></i> &nbsp; </h2></a></li>
              </ul>
        </div>
        : 
        <nav className={`w3-sidenav heading-grey my-side-nav`} >

          <ul className={`heading-grey my-side-nav-ul`}>
                <li className={`${this.isActive('profileCard')}`} onClick={this.scrollToTop}><i className={`fa fa-arrow-up fa-fw w3-large w3-text-teal`}></i> &nbsp; </li>
                <li className={`${this.isActive('experience')}`} ><Link to="experience" offset={-10} smooth={true} duration={500} ><i className={`fa fa-suitcase fa-fw w3-large w3-text-teal`}></i> &nbsp; </Link></li>
                <li className={`${this.isActive('skills')}`}     ><Link to="skills" offset={-10} smooth={true} duration={500} ><i className={`fa fa-globe fa-fw w3-large w3-text-teal`}></i> &nbsp; </Link></li>
                <li className={`${this.isActive('references')}`} ><Link to="references" offset={-10} smooth={true} duration={500} ><i className={`fa fa-send-o fa-fw w3-large w3-text-teal`}></i> &nbsp; </Link></li>
                <li className={`${this.isActive('education')}`}  ><Link to="education" offset={-10} smooth={true} duration={500} ><i className={`fa fa-graduation-cap fa-fw w3-large w3-text-teal`}></i> &nbsp; </Link></li>
                <li className={`${this.isActive('awards')}`}     ><Link to="awards" offset={-10} smooth={true} duration={500} ><i className={`fa fa-trophy fa-fw w3-large w3-text-teal`}></i> &nbsp; </Link></li>
                <li className={`${this.isActive('about')}`}      ><Link to="about" offset={-10} smooth={true} duration={500} ><i className={`fa fa-user fa-fw w3-large w3-text-teal`}></i> &nbsp; </Link></li>

                <li className={`homeLink`}><a href="http://frazerk.net/resume.pdf" target="resumepdf"><i className={`fa fa-print fa-fw w3-large w3-text-cyan`}></i> &nbsp; </a></li>
                <li className={`homeLink`}><a href="http://frazerk.net" target="home">           <i className={`fa fa-home fa-fw w3-large w3-text-cyan`}></i> &nbsp; </a></li>
              </ul>
        </nav> 
        }

        <div className={`resumeContainer w3-container w3-content w3-margin-top`} style={{maxWidth:'1400px',}}>


          <div className={`resumeContainerSwitcher w3-row-padding`} >



            { /*  <!-- Left Column --> */ }
            <div className={`w3-twothird mainColumn`} >

              <div className={`w3-container`}>
                
                <WorkExperience wideScreen={this.wideScreen} isMobile={this.isMobile} infoClickFunction={this.infoClickFunction} setPage={this.changePage.bind(this)}/>
                <Skills wideScreen={this.wideScreen}  isMobile={this.isMobile}  infoClickFunction={this.infoClickFunction} screenWidth={this.state.width} setPage={this.changePage.bind(this)}/>
                <References wideScreen={this.wideScreen}  isMobile={this.isMobile} infoClickFunction={this.infoClickFunction} setPage={this.changePage.bind(this)}/>
                <Education wideScreen={this.wideScreen}  isMobile={this.isMobile} setPage={this.changePage.bind(this)}/>
                <Awards wideScreen={this.wideScreen}  isMobile={this.isMobile}  infoClickFunction={this.infoClickFunction} setPage={this.changePage.bind(this)}/>
                <About wideScreen={this.wideScreen} isMobile={this.isMobile} setPage={this.changePage.bind(this)}/>

              </div>

            { /* <!-- End Left Column --> */ }
            </div>

            <ProfileCard  isMobile={this.isMobile}  setPage={this.changePage.bind(this)} screenWidth={this.state.width}/>


            
          { /* <!-- End Grid --> */ }
          </div>
          
          { /* <!-- End Page Container --> */ }
        </div>

        <footer className={`w3-container w3-teal w3-center w3-margin-top`}>
          <p>
            {this.wideScreen ? '' : <a onClick={this.scrollToTop} className={`footerTopLink `}><i className={`fa fa-arrow-up fa-fw w3-xlarge w3-text-grey`}></i></a> }
            All written and designed by myself. Based on a <a href="http://www.w3schools.com/w3css/tryw3css_templates_cv.htm" className="invisbleLink" target="_blank">W3.CSS template</a> and powered by <a href="https://facebook.github.io/react/" className="invisbleLink" >React</a>
            <a href="http://frazerk.net" className={`footerHomeLink `}><i className={`fa fa-home fa-fw w3-xlarge w3-text-grey`}></i></a>
          </p>

        </footer>
         

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js